import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { Drawer } from './Drawer';
import SideMenuOption from './SideMenuOption';
import styles from './AsideNavigationMenu.module.scss';
import { PAGES } from 'src/constants/pages';
import { ASIDE_MENU_COMPANY_LINKS, ASIDE_MENU_MANAGER_LINKS, ASIDE_MENU_VIEWER_LINKS } from 'src/constants/routes';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { userEditRoleSelector, userRoleSelector } from 'src/redux/selectors';
import { useSelector } from 'react-redux';
import { ACCESS_MODE } from 'src/interfaces/workspacesReduxShapes';

interface AsideMenuProps {
  isOpen: boolean;
}

const AsideNavigationMenu = ({ isOpen }: AsideMenuProps): JSX.Element => {
  const {
    location: { pathname }
  } = useHistory();

  const userRole = useSelector(userRoleSelector);
  const userEditRole = useSelector(userEditRoleSelector);

  const sideMenuLinks = useMemo(() => {
    if (userRole === ACCOUNT_ROLES.COMPANY) {
      return ASIDE_MENU_COMPANY_LINKS;
    }

    if (userEditRole === ACCESS_MODE.VIEWER) {
      return ASIDE_MENU_VIEWER_LINKS;
    }

    if (userEditRole === ACCESS_MODE.EDITOR) {
      return ASIDE_MENU_MANAGER_LINKS;
    }

    return ASIDE_MENU_VIEWER_LINKS;
  }, [userEditRole, userRole]);

  const onCheckIsActiveLink = (pathname: string, linkOptionPath: string) => {
    if (linkOptionPath === PAGES.INVESTMENTS) {
      return pathname.includes(PAGES.OUTSTANDING_BIDS);
    }

    return pathname.includes(linkOptionPath);
  };

  return (
    <Drawer variant="permanent" open={isOpen}>
      <ul className={styles.menuList}>
        {sideMenuLinks.map(({ path, ...rest }) => {
          const { title: popoverTitle } = sideMenuLinks.find((links) => links.path === path);

          const isActive = onCheckIsActiveLink(pathname, path);

          return (
            <SideMenuOption
              key={path}
              path={path}
              isAsideOpen={isOpen}
              popoverTitle={popoverTitle}
              isActive={isActive}
              {...rest}
            />
          );
        })}
      </ul>
    </Drawer>
  );
};

export default AsideNavigationMenu;
